import React from "react";
import webui from "@tinqin/tinqin-web-ui";

function CalculationResult(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["value", "label", "subtext"],
        propsDefaults: {
            value: 0
        }
    });
    return (
        <div className="tq-flex-container tq-flex-item-l-2 tq-flex-item-m-2 tq-flex-item-s-1 un-offer-simulation-content">
            <div className="tq-flex-item un-offer-simulation-left">
                <h2 className="tq-title">
                    <span className="tq-text-node">{dataProps.label}</span>
                </h2>
                {dataProps.subtext && (
                    <div className="un-offer-simulation-footnote">
                        <p>{dataProps.subtext}</p>
                    </div>
                )}
            </div>
            <div className="tq-flex-item un-offer-simulation-right">
                <span className="tq-text-node tq-title tq-title-inline tq-secondary-color-3 un-offer-price">
                    {new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(
                        dataProps.value
                    )}
                </span>
                <span className="tq-text-node tq-title tq-title-inline">€</span>
            </div>
        </div>
    );
}

export default webui.connectComponent()(CalculationResult);
